/**
 * Constants.
 */

// Player skins.
export const PLAYER_SKINS = {
	DEFAULT: 'Default',
	MINIMAL: 'Minimal',
	PILLS: 'Pills',
	CLASSIC: 'Classic',
};

/**
 * Form types.
 */
export const FORM_TYPES = {
	GRAVITY: 'gravity',
	WPFORMS: 'wpforms',
	EVEREST: 'everestforms',
	CF7: 'cf7',
	JETPACK: 'jetpack',
	SUREFORMS: 'sureforms',
	FORMINATOR: 'forminator',
	FLUENT: 'fluentforms',
	NINJA: 'ninjaforms',
	METFORM: 'metform',
};

/**
 * Hotspot constants.
 */
export const HOTSPOT_CONSTANTS = {
	DEFAULT_DIAMETER_PERCENT: 15,
	DEFAULT_DIAMETER_PX: 48,
	MIN_PX: 10,
	MIN_PERCENT_FALLBACK: 5,
	BASE_WIDTH: 800,
	BASE_HEIGHT: 600,
};

/**
 * Product Hotspot constants.
 */
export const PRODUCT_HOTSPOT_CONSTANTS = {
	DEFAULT_DIAMETER_PERCENT: 15,
	DEFAULT_DIAMETER_PX: 48,
	MIN_PX: 10,
	MIN_PERCENT_FALLBACK: 5,
	BASE_WIDTH: 800,
	BASE_HEIGHT: 600,
};

/**
 * Layer types.
 *
 * NOTE: Add-ons can register custom layer types using:
 * import { registerLayerType } from './layer-registry.js';
 * registerLayerType( 'custom-id', {
 *   label: 'Custom Layer',
 *   validator: (layer, dependencies) => true,
 *   manager: CustomLayerManager // optional
 * });
 */
export const LAYER_TYPES = {
	FORM: 'form',
	CTA: 'cta',
	POLL: 'poll',
	HOTSPOT: 'hotspot',
	WOOCOMMERCE: 'woo',
};

/**
 * Get dynamic layer types (including add-on registered types)
 * Use this if you need to access dynamically registered layer types
 *
 * @return {Object} Object with all available layer types
 */
export { getLayerTypes } from './layer-registry.js';

/**
 * Keyboard controls.
 */
export const KEYBOARD_CONTROLS = {
	FULLSCREEN: 'f',
	SEEK_BACKWARD: 'arrowleft',
	SEEK_FORWARD: 'arrowright',
	PLAY_PAUSE: ' ',
	PLAY_PAUSE_ALT: 'spacebar',
	ENTER: 'Enter',
	SPACE: ' ',
	ESCAPE: 'Escape',
};

/**
 * Engagements.
 */
export const ACTIONS = {
	LOAD_VIDEO_ENGAGEMENT_DATA: 'LOAD_VIDEO_ENGAGEMENT_DATA',
	USER_HIT_LIKE: 'USER_HIT_LIKE',
	USER_COMMENTED: 'USER_COMMENTED',
	GENERATE_COMMENT_MODAL: 'GENERATE_COMMENT_MODAL',
	UPDATE_USER_DATA: 'UPDATE_USER_DATA',
	ERROR: 'ERROR',
	ADD_VIDEO_MARKUP: 'ADD_VIDEO_MARKUP',
};
